import React from 'react'
import styled from 'styled-components'

const Wrap = styled.section`
  margin-top: 24px;
`

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 14px;
  border-bottom: 4px solid #33becc;
  padding-bottom: 8px;
`

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #0c1229;
`

const Box = styled.div`
  background: #fcfdfe;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  padding: 16px 20px;
`

const RefRow = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr auto;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f2f2f2;
  font-size: 12px;
  align-items: center;
  &:last-child { border-bottom: none; }
`

const Num = styled.div`
  color: #d24724;
  font-weight: 600;
  font-size: 11px;
`

const KindBadge = styled.span`
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  margin-right: 6px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  ${({ kind }) => {
    if (kind === 'file' || kind === 'fileVersion' || kind === 'file_version') return 'background:#ecfeff;color:#0e7490;'
    if (kind === 'email') return 'background:#fef3c7;color:#92400e;'
    if (kind === 'note') return 'background:#ede9fe;color:#6d28d9;'
    if (kind === 'task') return 'background:#ecfdf5;color:#065f46;'
    if (kind === 'incident' || kind === 'faultReport' || kind === 'fault_report') return 'background:#fef2f2;color:#b91c1c;'
    if (kind === 'annotation') return 'background:#fef3c7;color:#92400e;'
    if (kind === 'bp' || kind === 'bpField' || kind === 'bp_field') return 'background:#fbede9;color:#d24724;'
    if (kind === 'legislation') return 'background:#e0f2fe;color:#075985;'
    return 'background:#f2f2f2;color:#333;'
  }}
`

const When = styled.div`
  color: #999;
  font-size: 11px;
`

const friendlyKind = (kind) => {
  if (kind === 'fileVersion' || kind === 'file_version') return 'File'
  if (kind === 'faultReport' || kind === 'fault_report') return 'Fault'
  if (kind === 'bpField' || kind === 'bp_field') return 'Building Passport field'
  if (kind === 'legislation') return 'Law'
  return (kind || '').replace(/_/g, ' ')
}

const isExternalLink = (href) =>
  typeof href === 'string' && /^https?:\/\//i.test(href)

const formatDate = (iso) => {
  if (!iso) return ''
  try {
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
  } catch {
    return iso
  }
}

const WikiReferences = ({ references, activeRefId }) => (
  <Wrap id="section-references">
    <Head>
      <Title>References</Title>
      <div style={{ fontSize: 11, color: '#999', letterSpacing: '0.2px' }}>
        {(references || []).length} {references?.length === 1 ? 'source' : 'sources'} cited
      </div>
    </Head>
    <Box>
      {(references || []).map((r) => (
        <RefRow
          key={`${r.marker}-${r.refId}`}
          id={`ref-${r.refId}`}
          style={activeRefId === r.refId ? { background: '#fffbe6' } : undefined}
        >
          <Num>[{r.marker}]</Num>
          <div>
            <KindBadge kind={r.sourceKind}>{friendlyKind(r.sourceKind)}</KindBadge>
            {r.deepLink ? (
              <a
                href={r.deepLink}
                style={{ color: '#0645ad', textDecoration: 'none' }}
                {...(isExternalLink(r.deepLink) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {r.display}{isExternalLink(r.deepLink) ? ' ↗' : ''}
              </a>
            ) : (
              <span>{r.display}</span>
            )}
            {r.secondary && <span style={{ color: '#999', marginLeft: 6 }}>· {r.secondary}</span>}
          </div>
          <When>{formatDate(r.capturedAt)}</When>
        </RefRow>
      ))}
    </Box>
  </Wrap>
)

export default WikiReferences
